// For full API documentation, including code examples, visit http://wix.to/94BuAAs
var globalStrip = 0;

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function columnStrip18_viewportEnter_1(event) {
		if (globalStrip === 0) {

		const assetsMaxVal = Number($w("#assets").text);
		const workSpaceMaxVal = Number($w("#workspace").text);
		const balanceMaxVal = Number($w("#balance").text);

		var countassets = 0;
		var countworkspace = 0;
		var countbalance = 0.0;

		setInterval(function () {
			if (countassets < assetsMaxVal) {
				$w("#assets").text = String(++countassets);
			}
		}, 100);

		setInterval(function () {
			if (countworkspace < workSpaceMaxVal) {
				$w("#workspace").text = String(++countworkspace);
			}
		}, 5);

		setInterval(function () {
			if (countbalance < balanceMaxVal) {
				countbalance += 0.1;
				$w("#balance").text = String(countbalance.toFixed(1));
				console.log(countbalance.toFixed(1))
			}
		}, 60);
		globalStrip++;
	}
}